import { Controller } from 'react-hook-form';
import DatePicker from './DatePicker';

export const ControlDatePicker = ({
  control,
  name,
  rules = {},
  label,
  ...restDateProps
}) => {
  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({ field: { ref, ...rest } }) => (
        <DatePicker
          inputFormat="MMM dd, yyyy"
          inputRef={ref}
          label={label}
          {...restDateProps}
          {...rest}
        />
      )}
    />
  );
};
